import * as types from './types'
import * as integration from '../../../integration'

export const receiveSearch = (payload, feature) => ({
  type: types.RECEIVE_SEARCH,
  payload,
  feature
})

export const fetchSearch = (payload = true) => ({
  type: types.FETCH_SEARCH,
  payload
})

export const clearSearch = () => ({
  type: types.CLEAR_SEARCH
})

export const getSearch = (search) => async (dispatch) => {
  dispatch(fetchSearch())

  try {
    const wallet = await integration.resources.wallet.requests.getWallets({
      params: { ...search, order_by: 'name_fantasy', order_by_direction: 'asc' }
    })

    dispatch(receiveSearch(wallet.data, 'wallet'))
  } catch (err) {
    dispatch(fetchSearch(false))
  }

  try {
    const knowledgeBases =
      await integration.resources.knowledgeBases.requests.getKnowledgeBases({
        params: search
      })

    dispatch(receiveSearch(knowledgeBases.data, 'knowledgeBases'))
  } catch (err) {
    dispatch(fetchSearch(false))
  }
}
